(() => {
  const routineKey = 'innovapharm_draft_routine_v1';
  const readRoutine = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(routineKey));
      return saved && saved.schema === 1 && ['mvpre-3-0','mvpre-365'].includes(saved.handle) && /^\d+$/.test(String(saved.variantId)) ? saved : null;
    } catch { return null; }
  };
  const refreshRoutine = () => {
    const saved = readRoutine();
    document.querySelectorAll('[data-ip-routine]').forEach(block => {
      let catalog;
      try { catalog = JSON.parse(block.querySelector('[data-routine-catalog]').textContent); } catch { block.hidden = true; return; }
      const product = saved && catalog.find(item => item.handle === saved.handle);
      const variant = product && product.variants.find(item => String(item.id) === String(saved.variantId));
      block.hidden = !variant;
      if(!variant) return;
      block.querySelector('[data-routine-name]').textContent = product.title + ' / ' + variant.title;
      block.querySelector('[data-routine-price]').textContent = variant.price;
      block.querySelector('[data-routine-stock]').textContent = variant.available ? '' : block.dataset.soldLabel;
      const link = block.querySelector('[data-routine-link]');
      link.href = product.url + '?view=ip-preview' + (variant.available ? '&variant=' + variant.id : '');
      link.textContent = variant.available ? block.dataset.returnLabel + ' ↗' : block.dataset.otherLabel + ' ↗';
    });
    document.querySelectorAll('[data-routine-controls]').forEach(control => {control.querySelector('[data-routine-clear]').hidden = !saved;});
  };
  window.addEventListener('storage', event => {if(event.key === routineKey) refreshRoutine();});
  function initialize(root = document) {
    root.querySelectorAll('[data-routine-clear]').forEach(button => {
      if(button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const control = button.closest('[data-routine-controls]');
        try {
          localStorage.removeItem(routineKey);
          refreshRoutine();
          if(control) control.querySelector('[data-routine-status]').textContent = control.dataset.clearedLabel;
        } catch {
          if(control) control.querySelector('[data-routine-status]').textContent = control.dataset.errorLabel;
        }
      });
    });
    root.querySelectorAll('[data-ip-collection]').forEach(collection => {
      if(collection.dataset.initialized) return;
      collection.dataset.initialized = 'true';
      const choose = (family = location.hash === '#daily' ? 'daily' : 'active') => {
        collection.querySelectorAll('[data-family-panel]').forEach(panel => panel.hidden = panel.dataset.familyPanel !== family);
        collection.querySelectorAll('[data-family]').forEach(link => link.setAttribute('aria-current', String(link.dataset.family === family)));
      };
      window.addEventListener('hashchange', () => choose());
      collection.querySelectorAll('[data-family]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        const family = link.dataset.family;
        choose(family);
        if(window.self === window.top) history.replaceState({},'', '#'+family);
      }));
      choose();
    });
    root.querySelectorAll('.ip-mobile-menu a').forEach(link => link.addEventListener('click', () => link.closest('details').open = false));
    root.querySelectorAll('[data-ip-product]').forEach(product => {
      if(product.dataset.initialized) return;
      product.dataset.initialized = 'true';
      const previewLocked = product.dataset.previewLocked === 'true';
      const variants = JSON.parse(product.querySelector('[data-ip-variants]').textContent);
      const select = product.querySelector('[data-ip-variant]');
      const form = select.closest('form');
      const buttons = product.querySelectorAll('[data-ip-add]');
      const status = product.querySelector('[data-ip-status]');
      const referenceNotice = product.querySelector('[data-variant-notice]');
      const routineControls = product.querySelector('[data-routine-controls]');
      routineControls.querySelector('[data-routine-save]').addEventListener('click', () => {
        const variant = variants.find(item => String(item.id) === select.value);
        if(!variant) return;
        try {
          localStorage.setItem(routineKey,JSON.stringify({schema:1,handle:product.dataset.productHandle,variantId:String(variant.id)}));
          refreshRoutine();
          routineControls.querySelector('[data-routine-status]').textContent = routineControls.dataset.savedLabel;
        } catch {routineControls.querySelector('[data-routine-status]').textContent = routineControls.dataset.errorLabel;}
      });
      product.querySelectorAll('[data-gallery]').forEach(button => button.addEventListener('click', () => {
        const choice = button.dataset.gallery;
        product.querySelectorAll('[data-gallery-panel]').forEach(panel => panel.hidden = panel.dataset.galleryPanel !== choice);
        product.querySelectorAll('[data-gallery]').forEach(control => control.setAttribute('aria-pressed', String(control.dataset.gallery === choice)));
      }));
      const update = (setUrl = true) => {
        const variant = variants.find(item => String(item.id) === select.value);
        if(!variant) return;
        if(referenceNotice){
          const matches = variant.title.trim().toLowerCase() === product.dataset.referenceFlavor.toLowerCase();
          referenceNotice.hidden = matches;
          referenceNotice.textContent = matches ? '' : product.dataset.mismatchMessage.replace('__FLAVOR__',variant.title);
        }
        product.querySelectorAll('[data-ip-price],[data-ip-sticky-price]').forEach(el => el.innerHTML = variant.price);
        buttons.forEach(button => {button.disabled = previewLocked || !variant.available; button.textContent = previewLocked ? product.dataset.lockedLabel : variant.available ? product.dataset.addLabel : product.dataset.soldLabel;});
        const stackLink = product.querySelector('[data-stack-entry]');
        if(stackLink){ const target = new URL(stackLink.href);target.searchParams.set('variant',variant.id);stackLink.href=target.href; }
        const image = product.querySelector('#ip-main-product-image');
        if(image && variant.image){ image.removeAttribute('srcset'); image.src = variant.image; if(!variant.image.includes('ip-mv3-v8-mockup')) image.alt = variant.title; }
        if(setUrl && window.self === window.top){ const url = new URL(location.href); url.searchParams.set('variant',variant.id); history.replaceState({},'',url); }
        status.textContent = '';
        routineControls.querySelector('[data-routine-status]').textContent = '';
      };
      update(false);
      select.addEventListener('change', () => update());
      window.addEventListener('popstate',()=>{ const value = new URL(location.href).searchParams.get('variant');if(variants.some(v=>String(v.id)===value)){select.value=value;update(false);} });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if(previewLocked) return;
        if(!form.reportValidity()) return;
        const variant = variants.find(item=>String(item.id)===select.value);
        if(!variant?.available) return;
        buttons.forEach(b=>{b.disabled=true;b.textContent=product.dataset.addingLabel;});
        try {
          const base = window.Shopify?.routes?.root || '/';
          const response = await fetch(base+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
          const result = await response.json();
          if(!response.ok) throw new Error(result.description || product.dataset.errorLabel);
          status.textContent = product.dataset.addedLabel;
          product.querySelector('[data-ip-view-cart]').hidden=false;
          const cartResponse=await fetch(base+'cart.js',{headers:{Accept:'application/json'}});
          if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent='('+cart.item_count+')');}
        } catch(error){status.textContent=error.message || product.dataset.errorLabel;}
        finally {buttons.forEach(b=>{b.disabled=previewLocked||!variant.available;b.textContent=previewLocked?product.dataset.lockedLabel:variant.available?product.dataset.addLabel:product.dataset.soldLabel;});}
      });
      const dialog = product.querySelector('.ip-lab-dialog');
      product.querySelector('[data-open-lab]').addEventListener('click',()=>dialog.showModal());
      dialog.querySelectorAll('[data-close-lab]').forEach(b=>b.addEventListener('click',()=>dialog.close()));
      dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    });
    refreshRoutine();
  }
  initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();

(() => {
  const confirmation = document.querySelector('[data-ip-contact-success]');
  if (!confirmation) return;
  const revealConfirmation = () => {
    confirmation.focus({ preventScroll: true });
    confirmation.scrollIntoView({ block: 'center', behavior: 'instant' });
  };
  if (document.readyState === 'complete') revealConfirmation();
  else window.addEventListener('load', revealConfirmation, { once: true });
})();


(() => {
  document.querySelectorAll('[data-ip-review-carousel]').forEach(section => {
    const viewport = section.querySelector('[data-review-viewport]');
    const group = section.querySelector('.ip-home-review-group');
    const toggle = section.querySelector('[data-review-toggle]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reduced.matches;
    let focused = false;
    let resumeAt = 0;
    let visible = true;
    let last = 0;
    let cycleWidth = group.getBoundingClientRect().width;
    let position = viewport.scrollLeft;
    const updateToggle = () => {
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.textContent = paused ? toggle.dataset.resumeLabel : toggle.dataset.pauseLabel;
    };
    updateToggle();
    toggle.addEventListener('click', () => { paused = !paused; resumeAt = 0; updateToggle(); });
    section.addEventListener('focusin', event => { focused = viewport.contains(event.target) && event.target.matches(':focus-visible'); });
    section.addEventListener('focusout', event => { focused = viewport.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible'); });
    const pauseBriefly = () => { resumeAt = performance.now() + 8000; };
    viewport.addEventListener('pointerdown', pauseBriefly);
    viewport.addEventListener('keydown', event => { if (['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) pauseBriefly(); });
    const step = direction => {
      pauseBriefly();
      const card = group.querySelector('.ip-home-review-card');
      viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + (innerWidth <= 700 ? 16 : 24)), behavior: reduced.matches ? 'instant' : 'smooth' });
    };
    section.querySelector('[data-review-previous]').addEventListener('click', () => step(-1));
    section.querySelector('[data-review-next]').addEventListener('click', () => step(1));
    reduced.addEventListener('change', () => { if (reduced.matches) { paused = true; updateToggle(); } });
    new ResizeObserver(() => { cycleWidth = group.getBoundingClientRect().width; }).observe(group);
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }).observe(section);
    const tick = now => {
      const elapsed = last ? Math.min(now - last, 80) : 0;
      last = now;
      if (!paused && now >= resumeAt && !focused && visible && !document.hidden && cycleWidth > 0) {
        position = (position + elapsed * 0.03) % cycleWidth;
        viewport.scrollLeft = position;
      } else {
        position = viewport.scrollLeft;
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  });
})();
